import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

// Delta vs période de comparaison : flèche + couleur, « — » sans base
// (nouvelle entrée, période vide). Partagé par les rapports premium.
export default function DeltaBadge({ value, suffix = '%' }) {
  if (value === null || value === undefined) return <span className="rv-delta rv-delta--na">—</span>;
  const up = value > 0;
  const flat = value === 0;
  return (
    <span className={`rv-delta ${flat ? '' : up ? 'is-plus' : 'is-moins'}`}>
      {flat ? '=' : up ? <ArrowUpOutlined /> : <ArrowDownOutlined />} {Math.abs(value)}{suffix}
    </span>
  );
}
